import { useId as useReactAriaId } from '@react-aria/utils';

/**
 * Private module reserved for @coursera/cds-core package.
 *
 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
 *
 * A string can be supplied as an argument to useId in lieu of the auto-generated ID.
 * This is handy for accepting user-provided prop IDs that need to be deterministic.
 *
 * Known issues:
 *
 *  - StrictMode issue @see https://github.com/adobe/react-spectrum/issues/779
 */
const useId = (idFromProps?: string): string => {
  const id = useReactAriaId(idFromProps);

  if (idFromProps) {
    return idFromProps;
  }

  return `cds-${id}`;
};

export default useId;
